import { Component, signal } from '@angular/core';
import { AppstateService } from './services/appstate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(public appStateService: AppstateService,
    ) {

  }

  ngOnInit() {
    this.appStateService.initAppStateFromLocalStorage();
  }

  

  
}
